/*
    Will make an array with object from raw Metar.
    Cares only about main wind and change groups with winds. Returns:
    [
      {
        "title": "METAR",
        "windDegrees": 330,
        "windSpeed": 12
      }
    ]
*/
export const formatMetarToWindArray = (rawMetar, isTrainingMode = false) => {
  if (!rawMetar) return [];

  if (Array.isArray(rawMetar)) {
    rawMetar = rawMetar.join(" ");
  }

  return isTrainingMode
    ? formatTrainingMetarToWindArray(rawMetar)
    : formatStandardMetarToWindArray(rawMetar);
};

/*
    Standard METAR format
*/
const formatStandardMetarToWindArray = (rawMetar) => {
  const result = [];

  const mainWindRegex = /\b(VRB|\d{3})(\d{2})(?:G(\d{2}))?KT\b/;
  const mainWindMatch = mainWindRegex.exec(rawMetar);
  if (mainWindMatch) {
    result.push({
      title: "METAR",
      windDegrees:
        mainWindMatch[1] === "VRB" ? "VRB" : parseInt(mainWindMatch[1], 10),
      windSpeed: parseInt(mainWindMatch[2], 10),
      windGust: mainWindMatch[3] ? parseInt(mainWindMatch[3], 10) : null,
    });
  }

  const rmkIndex = rawMetar.indexOf("RMK");

  let metarToProcess = rmkIndex !== -1 ? rawMetar.slice(0, rmkIndex) : rawMetar;

  const changeGroupWithWindRegex =
    /\b(TEMPO|BECMG|PROB30|PROB40)\b(?:.*?)\b(\d{3})(\d{2})(?:G(\d{2}))?KT\b/g;

  let changeGroupMatch;
  while (
    (changeGroupMatch = changeGroupWithWindRegex.exec(metarToProcess)) !== null
  ) {
    const groupType = changeGroupMatch[1];
    const windDegrees = parseInt(changeGroupMatch[2], 10);
    const windSpeed = parseInt(changeGroupMatch[3], 10);
    const windGust = changeGroupMatch[4]
      ? parseInt(changeGroupMatch[4], 10)
      : null;

    result.push({
      title: `METAR ${groupType}`,
      windDegrees,
      windSpeed,
      windGust,
    });
  }

  return result;
};

/*
    Training METAR format - more permissive than standard format
*/
const formatTrainingMetarToWindArray = (rawMetar) => {
  const result = [];

  const windRegex = /(VRB|\d{3})(\d{2})(G\d{2})?KT/g;

  let match;
  while ((match = windRegex.exec(rawMetar)) !== null) {
    const gustMatch = match[3] ? match[3].replace("G", "") : null;
    result.push({
      title: result.length === 0 ? "METAR" : "METAR (alt)",
      windDegrees: match[1] === "VRB" ? "VRB" : parseInt(match[1], 10),
      windSpeed: parseInt(match[2], 10),
      windGust: gustMatch ? parseInt(gustMatch, 10) : null,
    });
  }

  return result;
};
